import { reclaimAccessDefaultsSchema } from "@redotech/redo-model/disputes/reclaim-access-settings";
import * as z from "zod";

// Merchants receive the full ReclaimAccessDefaults including sourceRules.
// Without sourceRules, the merchant UI can't render the correct copy for a
// given activation source (intake_modal, placeholder_landing, etc.) when
// admin has customized any source rule away from its build-time default —
// the UI would silently render against build-time constants instead.
export const getReclaimAccessDefaults = {
  name: "getReclaimAccessDefaults" as const,
  input: z.object({}),
  output: z.object({ defaults: reclaimAccessDefaultsSchema }),
};
